import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, ShieldCheck, ArrowRight, Trophy, Star, Lock, Clock, CreditCard, Zap } from 'lucide-react';
import { motion } from 'framer-motion';
export function OfferSection() {
  return <section id="comprar" className="px-4 max-w-5xl mx-auto pt-[1px] pb-[1px]" data-id="element-93">
      {/* Urgency Bar */}
      <FadeIn className="mb-8 -mt-8" data-id="element-94">
        <motion.div className="max-w-md mx-auto bg-mint/20 border-2 border-mint rounded-full px-6 py-3 flex items-center justify-center gap-3 shadow-lg shadow-mint/15" animate={{
        boxShadow: ['0 0 15px rgba(245,198,160,0.15)', '0 0 25px rgba(245,198,160,0.3)', '0 0 15px rgba(245,198,160,0.15)']
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-95">
          <div className="relative shrink-0" data-id="element-96">
            <span className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 bg-mint rounded-full animate-ping" data-id="element-97" />
            <span className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 bg-mint rounded-full" data-id="element-98" />
            <Clock size={18} className="text-mint" data-id="element-99" />
          </div>
          <div className="flex-1" data-id="element-100">
            <div className="flex items-center justify-between mb-1" data-id="element-101">
              <span className="text-mint text-sm font-bold" data-id="element-102">
                🔥 68% de los cupos tomados
              </span>
            </div>
            <div className="w-full bg-black/30 rounded-full h-2.5" data-id="element-103">
              <motion.div className="bg-gradient-to-r from-mint to-amber-400 h-2.5 rounded-full" initial={{
              width: 0
            }} whileInView={{
              width: '68%'
            }} transition={{
              duration: 1.2,
              ease: 'easeOut'
            }} viewport={{
              once: true
            }} data-id="element-104" />
            </div>
          </div>
        </motion.div>
      </FadeIn>

      <FadeIn className="text-center mb-8" data-id="element-105">
        <h2 className="text-3xl md:text-5xl text-mint mb-4 uppercase font-['Open_Sans',_sans-serif] font-[900]" data-id="element-106">
          ✏️ MEGAPACK + PLAN PRO
        </h2>
        <p className="text-lg md:text-xl text-white/70 font-medium" data-id="element-107">
          Bonos GRATIS incluidos siempre en las dos ofertas
        </p>
      </FadeIn>

      {/* Pricing Cards */}
      <div className="grid md:grid-cols-2 gap-8 mb-8" data-id="element-108">
        {/* Plan 1: Standard */}
        <FadeIn delay={0.1} className="bg-surface border border-mint/20 rounded-3xl p-8 flex flex-col relative" data-id="element-109">
          <div className="mb-4" data-id="element-110">
            <h3 className="text-white mb-2 text-[20px] font-[900] font-['Open_Sans',_sans-serif] uppercase" data-id="element-111">
              📚 MegaPack Lectoescritura
            </h3>
            <p className="text-white/50 text-sm font-medium" data-id="element-112">
              6 tomos + 6 bonos
            </p>
          </div>

          <div className="mb-6" data-id="element-113">
            <p className="text-white/40 line-through text-lg mb-1" data-id="element-114">$34.990</p>
            <p className="text-5xl font-[900] text-white font-['Open_Sans',_sans-serif]" data-id="element-115">
              $19.990
              <span className="text-base text-white/40 font-normal ml-2" data-id="element-116">
                ARS
              </span>
            </p>
          </div>

          <ul className="space-y-2 mb-6 flex-1" data-id="element-117">
            <li className="flex items-start gap-2 text-white/70 text-sm" data-id="element-118">
              <Check size={16} className="text-mint shrink-0 mt-0.5" data-id="element-119" />
              <span data-id="element-120">MegaPack completo (6 tomos · +360 páginas)</span>
            </li>
            <li className="flex items-start gap-2 text-white/70 text-sm" data-id="element-121">
              <Check size={16} className="text-mint shrink-0 mt-0.5" data-id="element-122" />
              <span data-id="element-123">6 Bonos estratégicos GRATIS</span>
            </li>
            <li className="flex items-start gap-2 text-white/40 text-sm line-through" data-id="element-124">
              <span className="w-4 shrink-0" data-id="element-125" />
              <span data-id="element-126">Plan PRO (no incluido)</span>
            </li>
          </ul>

          <a href="https://salud-en-tu-plato.myshopify.com/checkouts/cn/hWNBvyqtR3EsBTUjzFejQxik/es-ar?_r=AQABaLwowYczX5mq7ia3puARWTgZMfh_Ye-Moflp1E3hhIg&cart_link_id=nUXSoC3U&preview_theme_id=151828791463" target="_blank" rel="noopener noreferrer" className="w-full block text-center bg-white/10 hover:bg-white/15 text-white font-bold py-4 rounded-xl transition-colors border border-white/10" data-id="element-127">
            QUIERO LA VERSIÓN BASE
          </a>
        </FadeIn>

        {/* Plan 2: Plus (Highlighted) */}
        <FadeIn delay={0.2} id="oferta-pro" className="bg-surface border-2 border-mint rounded-3xl p-8 flex flex-col relative transform md:-translate-y-4 shadow-2xl shadow-mint/10 scroll-mt-24" data-id="element-128">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-mint text-black font-bold px-5 py-1.5 rounded-full text-sm flex items-center gap-1.5" data-id="element-129">
            <Star size={14} fill="currentColor" data-id="element-130" /> MÁS ELEGIDO
          </div>

          <div className="mb-4 mt-2" data-id="element-131">
            <h3 className="text-mint mb-2 text-[20px] font-[900] font-['Open_Sans',_sans-serif] uppercase" data-id="element-132">
              🚀 MegaPack + PLAN PRO
            </h3>
            <p className="text-white/50 text-sm font-medium" data-id="element-133">
              6 tomos + 6 bonos + PLAN PRO (Rutas, Informes, Agenda, Mapa de
              Decisión y Devoluciones profesionales)
            </p>
          </div>

          <div className="inline-flex self-start items-center gap-1.5 bg-mint/15 border border-mint/30 text-mint text-xs font-bold px-3 py-1.5 rounded-full mb-4" data-id="element-134">
            <Trophy size={14} data-id="element-135" /> AHORRÁS $98.970
          </div>

          <div className="mb-6" data-id="element-136">
            <p className="text-white/40 line-through text-lg mb-1" data-id="element-137">$126.960</p>
            <p className="text-5xl font-[900] text-mint font-['Open_Sans',_sans-serif]" data-id="element-138">
              $27.990
              <span className="text-base text-white/40 font-normal ml-2" data-id="element-139">
                ARS
              </span>
            </p>
          </div>

          <ul className="space-y-3 mb-6 flex-1" data-id="element-140">
            <li className="flex items-start gap-3 text-white/80 text-sm" data-id="element-141">
              <Check size={18} className="text-mint shrink-0 mt-0.5" data-id="element-142" />
              <span data-id="element-143">MegaPack completo (6 tomos + 6 bonos)</span>
            </li>
            <li className="border-t border-mint/10 pt-3 flex items-start gap-3 text-mint text-sm font-medium" data-id="element-144">
              <span className="text-xs uppercase tracking-wider mt-0.5" data-id="element-145">
                + PLAN PRO incluido
              </span>
            </li>
            <li className="flex items-start gap-3 text-white/80 text-sm" data-id="element-146">
              <Check size={18} className="text-mint shrink-0 mt-0.5" data-id="element-147" />
              <span data-id="element-148">Rutas de Intervención PRO</span>
            </li>
            <li className="flex items-start gap-3 text-white/80 text-sm" data-id="element-149">
              <Check size={18} className="text-mint shrink-0 mt-0.5" data-id="element-150" />
              <span data-id="element-151">Informes PRO listos para adaptar</span>
            </li>
            <li className="flex items-start gap-3 text-white/80 text-sm" data-id="element-152">
              <Check size={18} className="text-mint shrink-0 mt-0.5" data-id="element-153" />
              <span data-id="element-154">Agenda PRO del consultorio</span>
            </li>
            <li className="flex items-start gap-3 text-white/80 text-sm" data-id="element-155">
              <Check size={18} className="text-mint shrink-0 mt-0.5" data-id="element-156" />
              <span data-id="element-157">Mapa PRO de decisión psicopedagógica</span>
            </li>
            <li className="flex items-start gap-3 text-white/80 text-sm" data-id="element-158">
              <Check size={18} className="text-mint shrink-0 mt-0.5" data-id="element-159" />
              <span data-id="element-160">Kit PRO de devoluciones profesionales</span>
            </li>
            <li className="border-t border-mint/10 pt-3 mt-1" data-id="element-161">
              <motion.div className="flex items-center gap-3 bg-mint/10 border border-mint/30 rounded-lg px-3 py-2.5" animate={{
              boxShadow: ['0 0 0px rgba(245,198,160,0)', '0 0 12px rgba(245,198,160,0.25)', '0 0 0px rgba(245,198,160,0)']
            }} transition={{
              duration: 2.5,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-162">
                <span className="text-lg" data-id="element-163">💼</span>
                <span className="text-mint font-bold text-sm" data-id="element-164">
                  Sistema profesional completo
                </span>
                <span className="ml-auto bg-mint text-black text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wide" data-id="element-165">
                  PRO
                </span>
              </motion.div>
            </li>
          </ul>
        </FadeIn>
      </div>

      {/* Main CTA */}
      <FadeIn delay={0.3} className="text-center mb-6" data-id="element-166">
        <motion.a href="https://salud-en-tu-plato.myshopify.com/checkouts/cn/hWNBvzMx9estqPMwINrnPEgs/es-ar?_r=AQABsXkQ-ipPbCrMJMT_FV43Nlbo8215Uztaf_gOAXX9L5Q&cart_link_id=p9K0f5sJ&preview_theme_id=151828791463" target="_blank" rel="noopener noreferrer" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="block w-full max-w-2xl mx-auto bg-gradient-to-r from-mint to-amber-400 hover:from-mint/90 hover:to-amber-400/90 text-black font-[900] text-lg md:text-xl py-5 px-8 rounded-2xl shadow-xl shadow-mint/20 transition-all font-['Open_Sans',_sans-serif] text-center" data-id="element-167">
          🚀 ¡SÍ! QUIERO EL PLAN PRO
        </motion.a>
        <p className="text-white/50 text-sm mt-4 italic" data-id="element-168">
          La opción elegida por psicopedagogas y docentes que quieren
          profesionalizar su trabajo
        </p>
      </FadeIn>

      {/* Trust Bar */}
      <FadeIn delay={0.4} className="mb-12" data-id="element-169">
        <div className="flex flex-wrap justify-center gap-6 md:gap-10 bg-surface border border-mint/10 rounded-2xl py-5 px-6 max-w-3xl mx-auto" data-id="element-170">
          <div className="flex items-center gap-2 text-white/60 text-sm font-medium" data-id="element-171">
            <Lock size={16} className="text-mint" data-id="element-172" />
            Pago seguro
          </div>
          <div className="flex items-center gap-2 text-white/60 text-sm font-medium" data-id="element-173">
            <Zap size={16} className="text-mint" data-id="element-174" />
            Acceso inmediato
          </div>
          <div className="flex items-center gap-2 text-white/60 text-sm font-medium" data-id="element-175">
            <ShieldCheck size={16} className="text-mint" data-id="element-176" />
            Garantía 7 días
          </div>
          <div className="flex items-center gap-2 text-white/60 text-sm font-medium" data-id="element-177">
            <CreditCard size={16} className="text-mint" data-id="element-178" />
            Pago único
          </div>
        </div>
      </FadeIn>

      {/* Comparison Block */}
      <FadeIn delay={0.5} className="mb-12" data-id="element-179">
        <h3 className="text-2xl font-bold text-center text-white mb-6" data-id="element-180">
          MegaPack base vs MegaPack + PLAN PRO 🚀
        </h3>
        <div className="bg-surface border border-mint/10 rounded-2xl overflow-hidden" data-id="element-181">
          <div className="grid grid-cols-3 bg-white/5 p-4 border-b border-mint/10 font-bold text-sm md:text-base" data-id="element-182">
            <div className="text-white/60" data-id="element-183">Área</div>
            <div className="text-white/80 text-center" data-id="element-184">Base</div>
            <div className="text-mint text-center" data-id="element-185">+ PLAN PRO</div>
          </div>

          {[{
          area: 'Material',
          std: '6 tomos + 6 bonos',
          plus: 'Todo + recursos PRO'
        }, {
          area: 'Intervención',
          std: 'Actividades sueltas',
          plus: 'Rutas guiadas paso a paso'
        }, {
          area: 'Informes',
          std: 'Plantilla básica',
          plus: 'Modelos PRO listos para adaptar'
        }, {
          area: 'Decisión clínica',
          std: 'Criterio personal',
          plus: 'Mapa PRO de decisión'
        }, {
          area: 'Agenda',
          std: 'Manual',
          plus: 'Agenda PRO del consultorio'
        }, {
          area: 'Devoluciones',
          std: 'Improvisadas',
          plus: 'Kit PRO de devoluciones'
        }].map((row, i) => <div key={i} className="grid grid-cols-3 p-4 border-b border-mint/5 text-sm md:text-base items-center" data-id="element-186">
              <div className="font-medium text-white/70" data-id="element-187">{row.area}</div>
              <div className="text-center text-white/60" data-id="element-188">{row.std}</div>
              <div className="text-center text-mint font-medium flex items-center justify-center gap-2" data-id="element-189">
                <Check size={16} className="hidden md:block" data-id="element-190" /> {row.plus}
              </div>
            </div>)}
        </div>
      </FadeIn>

      {/* Objections */}
      <FadeIn delay={0.6} className="mb-12" data-id="element-191">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-192">
          <div className="bg-surface border border-mint/10 p-6 rounded-2xl" data-id="element-193">
            <h4 className="font-bold text-mint mb-2" data-id="element-194">¿Y si recién empiezo?</h4>
            <p className="text-white/70 text-sm" data-id="element-195">
              Te da estructura, secuencias y material listo para sostener
              procesos sin sentirte perdida en cada sesión.
            </p>
          </div>
          <div className="bg-surface border border-mint/10 p-6 rounded-2xl" data-id="element-196">
            <h4 className="font-bold text-mint mb-2" data-id="element-197">
              ¿Y si ya tengo experiencia?
            </h4>
            <p className="text-white/70 text-sm" data-id="element-198">
              Te ahorra horas de armado y te da un sistema pulido para escalar
              tu trabajo sin sacrificar tardes.
            </p>
          </div>
          <div className="bg-surface border border-mint/10 p-6 rounded-2xl" data-id="element-199">
            <h4 className="font-bold text-mint mb-2" data-id="element-200">¿Y si no me sirve?</h4>
            <p className="text-white/70 text-sm" data-id="element-201">
              Tenés 7 días de garantía total. Si no te suma valor, te devolvemos
              el dinero sin hacer preguntas.
            </p>
          </div>
        </div>
      </FadeIn>

      {/* Closing */}
      <FadeIn delay={0.7} className="text-center max-w-3xl mx-auto" data-id="element-202">
        <h3 className="text-3xl md:text-4xl font-display font-bold text-white mb-4" data-id="element-203">
          Dejá de sacrificar tus tardes armando material desde cero.
        </h3>
        <p className="text-xl text-mint/80 mb-8" data-id="element-204">
          Llevate el sistema que ya usan +850 profesionales y recuperá tu
          tiempo.
        </p>
        <button onClick={() => window.scrollTo({
        top: document.getElementById('comprar')?.offsetTop,
        behavior: 'smooth'
      })} className="inline-flex items-center justify-center gap-2 bg-mint hover:bg-mint/80 text-black font-bold text-lg py-5 px-10 rounded-xl shadow-xl shadow-mint/10 transition-all hover:scale-105" data-id="element-205">
          ELEGIR MI OPCIÓN AHORA <ArrowRight size={20} data-id="element-206" />
        </button>
      </FadeIn>
    </section>;
}